export default __webpack_public_path__ + "static/media/reviewPic2.f9bf8608.svg";